if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      connectedCallback() {
        this.currentHandle = this.dataset.currentHandle;
        this.maxItems = parseInt(this.dataset.maxItems, 10) || 4;
        this.grid = this.querySelector('.toylivo-recently-viewed__grid');
        this.storageKey = 'toylivo:recently-viewed';

        this.recordCurrentProduct();
        this.render();
      }

      recordCurrentProduct() {
        if (!this.currentHandle) return;
        let list = toylivoReadStorage(this.storageKey).filter((handle) => handle !== this.currentHandle);
        list.unshift(this.currentHandle);
        list = list.slice(0, 12);
        toylivoWriteStorage(this.storageKey, list);
      }

      async render() {
        if (!this.grid) return;

        const handles = toylivoReadStorage(this.storageKey)
          .filter((handle) => handle !== this.currentHandle)
          .slice(0, this.maxItems);

        if (handles.length === 0) return;

        const products = (await Promise.all(handles.map((handle) => this.fetchProduct(handle)))).filter(
          Boolean
        );

        if (products.length === 0) return;

        const currencyFormatter = this.getCurrencyFormatter();
        this.grid.innerHTML = products.map((product) => this.renderCard(product, currencyFormatter)).join('');
        this.removeAttribute('hidden');
      }

      getCurrencyFormatter() {
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
          });
        } catch (error) {
          return { format: (value) => `${currency} ${value.toFixed(2)}` };
        }
      }

      async fetchProduct(handle) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (!response.ok) return null;
          return await response.json();
        } catch (error) {
          return null;
        }
      }

      resizeImage(url) {
        if (!url) return '';
        return url.replace(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '_400x.$1$2');
      }

      renderCard(product, currencyFormatter) {
        const image = product.featured_image || (product.images && product.images[0]) || '';
        const imageUrl = this.resizeImage(image);
        const price = currencyFormatter.format(product.price / 100);
        const compareAtPrice =
          product.compare_at_price && product.compare_at_price > product.price
            ? currencyFormatter.format(product.compare_at_price / 100)
            : '';

        return `
          <li class="toylivo-recently-viewed__item grid__item">
            <a href="${toylivoEscapeHtml(product.url)}" class="toylivo-recently-viewed__card">
              <span class="toylivo-recently-viewed__media">
                ${
                  imageUrl
                    ? `<img src="${toylivoEscapeHtml(imageUrl)}" alt="${toylivoEscapeHtml(
                        product.title
                      )}" loading="lazy" width="400" height="400" class="toylivo-recently-viewed__image">`
                    : ''
                }
              </span>
              <span class="toylivo-recently-viewed__title">${toylivoEscapeHtml(product.title)}</span>
              <span class="toylivo-recently-viewed__price">
                ${compareAtPrice ? `<s>${compareAtPrice}</s> ` : ''}${price}
              </span>
            </a>
          </li>
        `;
      }
    }
  );
}
